import './ReviewPages.scss';

import React from 'react';
import {Container, Spinner} from "react-bootstrap";
import HandicaddieLogo from "../../../icons/HandicaddieLogo";

import Form from 'react-bootstrap/Form';
import {useDispatchedValue} from "../../../hooks/useDispatchedValue";
import {handleCaddieReviewLoad, handleClubCaddieFilter} from "../../../services/store/reducers/postRound/slice";

import {useAppDispatch} from "../../../services/store/store";
import {handicaddieSelector} from "../../../services/store/asyncThunk";

import {useNavigate} from 'react-router-dom';
import SelectableCaddie from "../components/SelectableCaddie";
import {ClubCaddie} from "../../../services/api/ClubCaddieService";
import {buildUrl, PAY_CADDIE} from "../../../services/PageUtils";


interface Props {

}

const FindYourCaddie = ({}: Props) => {

    const dispatch = useAppDispatch();

    const nav = useNavigate();

    const { filteredCaddies } = handicaddieSelector(state => state.postRound)

    const { setValue, dispatchValue, processing } = useDispatchedValue((searchTerm) => {
        dispatch(handleClubCaddieFilter(searchTerm))
    })

    const submit = (caddie: ClubCaddie) => {
        dispatch(handleCaddieReviewLoad({
                id: caddie.caddieId,
                name: caddie.displayName,
                userId: caddie.userId
            }
        ))

        nav(buildUrl(PAY_CADDIE))
    }

    return (
        <Container>
            <div className={"findYourCaddie_logoContainer"}>
                <HandicaddieLogo size={'lg'} />
            </div>

            <div>
                <span className={"heading"}>Find Your Caddie</span>
            </div>

            <Form.Label column={'lg'}>Caddie Search</Form.Label>
            <div className={"findYourCaddie_searchBarContainer"}>
                <Form.Control
                    type="text"
                    placeholder="Search..."
                    id="caddieSearch"
                    size={'lg'}
                    className={"findYourCaddie_searchInput"}
                    onChange={(e) => setValue(e.target.value)}
                    onSubmit={dispatchValue}
                />
                {processing && <Spinner className={"findYourCaddie_spinner"} />}
            </div>

            <div>
                {filteredCaddies.map((caddie) => {
                    return <SelectableCaddie
                        key={caddie.caddieId}
                        caddie={caddie}
                        onSelected={() => submit(caddie)}
                    />
                })}
            </div>
        </Container>
    )
}

export default FindYourCaddie;